<template lang="pug">
  #rfis
    #access(v-if="has_permission")
      transition(name="slide")
        chat(v-if="isChatVisible" @visible="setChatVisible")
      vm-row.heading(vm-w="12")
        vm-col(vm-w="3")
          .left-container
            .actions
              div.back
                vm-button(icon="arrow-back-outline" radius @click="goBack()" v-if="$route.params.id")
              vm-button.back(icon="arrow-ios-back-outline" @click="cleanRFIS()" type="flat" v-if="isRfis && $route.params.id == null")
              vm-input.search(ref="search" icon="search" size="small" placeholder="Search..." v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="100%" v-if="isRfis")
              vm-input.search(ref="search" icon="search" size="small" placeholder="Search..." v-model="filtersProjects.where.param" @keyup.enter="applyFilterProjects(filtersProjects)" width="100%" v-if="!isRfis")
              vm-button.new-rfi(icon="plus" @click="setChatVisible(true)" type="flat" v-if="rfis_store_permission") New
            miniatura-chat(v-if="isRfis" @open="view")
            miniatura-project(v-else @listRfi="getRfisList")
        vm-col.scroll(vm-w="9" v-if="isRfis")
          rfi(:rfi="rfi" @update="view" @empty="emptyRfi" v-if="rfi")
        vm-col(vm-w="9" v-if='!isRfis && projects.length > 0 & !$route.params.id')
          #SelectProject
            select-project
        vm-col(vm-w="9" v-if="!has_permission")
          #no-access(v-if="!has_permission")
            access-denied
        vm-col(vm-w="9" v-if="projects.length === 0 && !isLoading")
          #no-results(v-if="projects.length === 0 && !isLoading")
            no-results
</template>

<script>
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Rfis')

export default {
  name: 'Rfis',
  components: {
    MiniaturaChat: () => import('@/components/rfis/MiniaturaChat.vue'),
    MiniaturaProject: () => import('@/components/rfis/MiniaturaProject.vue'),
    Chat: () => import('@/components/rfis/Chat.vue'),
    Rfi: () => import('@/components/rfis/Rfi.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    NoResults: () => import('@/components/aditionals/NoResults.vue'),
    SelectProject: () => import('@/components/aditionals/SelectProjectRfi.vue')
  },
  data: () => ({
    rfi: {},
    isChatVisible: false,
    has_permission: true,
    rfis_store_permission: true,
    filters: {
      where: {
        created_by: '',
        rfi_number: '',
        param: ''
      },
      whereIn: {
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersProjects: {
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: { where: { param: '' } }
  }),
  beforeRouteLeave (to, from, next) {
    this.cleanRFIS()
    next()
  },
  created () {
    this.checkPermissionView('rfis.index')
    this.$route.params.id && this.getRfisList(this.$route.params.id)
  },
  methods: {
    ...mapActions([
      'loadProjects',
      'loadRfis',
      'actionRfi',
      'applyFilter',
      'applyFilterProjects',
      'cleanRFIS',
      'setIdProject'
    ]),
    goBack () {
      this.$router.go(-1)
    }, 
    setChatVisible (boolean) {
      this.isChatVisible = boolean
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.rfis_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'rfis.store') > -1
    },
    async view ({ record, action }) {
      let _rfi = record
      if (parseInt(record.pendiente) === 1 && record.created_by !== this.$auth.user().id) {
        await this.actionRfi({ id: record.id, action })
      }
      if (record.answer && !record.reply_date) {
        _rfi = this.rfis.find(e => e.id === record.id)
      }
      this.rfi = { ..._rfi }
    },
    async getRfisList (id) {
      this.setIdProject(id)
      this.loadRfis({ page: 1, id: id })
    },
    emptyRfi () {
      this.rfi = null
    }
  },
  computed: {
    ...mapGetters([
      'rfis',
      'projects',
      'filterParams',
      'filterParamsProject',
      'isLoading',
      'isRfis',
      'idProject'
    ])
  },
  watch: {
    filterParams (filter) {
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.loadRfis({ page: 1, id: this.idProject })
    },
    filterParamsProject (filter) {
      filter.length === 0 && (this.filtersProjects = parseVuexObject(this.filtersClear))
      this.loadProjects({ page: 1 })
    }
  }
}
</script>

<style lang="scss" scoped>
#rfis {
  padding: 0 15px;
}
.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .new-rfi {
    margin: 0 0 0 10px;
    flex-shrink: 0;
  }
  .back {
    margin-right: 5px;
  }
}
.scroll {
  height: calc(100vh - 110px);
  overflow-y: auto;
}
.left-container {
  display: flex;
  flex-direction: column;
}
#no-results {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
#SelectProject {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.slide-enter-active {
  transition: all .3s ease-in-out;
}
.slide-leave-active {
  transition: all .3s ease-in-out;
}
.slide-enter, .slide-leave-to {
  transform: translateY(90vh);
}
</style>
